<template>
  <div class="WorkspaceKnowledge">
    <div class="inline">
      <div class="inlineItem">
        <v-row class="WorkspaceKnowledge__files">
          <div
            class="WorkspaceKnowledge__filesContainer"
            v-if="!isFilesLoading"
          >
            <div v-for="(file, index) in files" :key="index" class="fileItem">
              <div
                style="
                  position: relative;
                  display: flex;
                  justify-content: start;
                "
              >
                <button @click.stop="onFileDelete(file.id)" class="closeButton">
                  <span>&times;</span>
                </button>
                <img
                  v-if="file.type.includes('image')"
                  :src="file.base64"
                  class="image"
                />
                <div style="height: 80px" @click="openFileModal(file)">
                  <img
                    v-if="!file.type.includes('image')"
                    class="document"
                    :src="`${publicPath}/icons/file-icon.svg`"
                  />
                </div>
                <span style="top: 0px">
                  {{ file.name }}
                </span>
              </div>
            </div>
          </div>
          <v-progress-circular
            :size="25"
            :width="2"
            v-if="isFilesLoading"
            color="primary"
            indeterminate
            style="margin-left: 49%; margin-right: 49%"
          />
          <v-progress-linear striped :value="getFilesSize()" :height="10">
            <template v-slot:default="{ value }">
              <span style="font-size: 10pt">{{ Math.ceil(value) }}%</span>
            </template>
          </v-progress-linear>
        </v-row>
      </div>
      <div class="WorkspaceKnowledge__attach_buttons_container">
        <v-file-input
          label="File input"
          hide-input
          v-model="files"
          class="WorkspaceKnowledge__attach_button"
          multiple
          accept=".md,.doc,.docx,.pdf,.csv,.txt,.html,.odt,.rtf,.epub,.jpeg,.png,.jpg,image/*"
          @change="onFileChange"
          style="margin-left: 8px; !important;"
        ></v-file-input>
        <v-btn icon @click="attachGoogleDriveOpen = true">
          <google-drive-icon class="WorkspaceKnowledge__google_icon" />
        </v-btn>
        <v-btn icon @click="attachOneDriveOpen = true">
          <one-drive-icon class="WorkspaceKnowledge__onedrive_icon" />
        </v-btn>
        <v-btn icon @click="openJsonEditModal = true">
          <v-icon> mdi-json </v-icon>
        </v-btn>
      </div>
    </div>

    <v-dialog :value="openFile" persistent @click:outside="openFile = false">
      <v-card style="display: flex; flex-direction: column">
        <v-card-title class="text-h5"> {{ openedFile?.name }} </v-card-title>
        <v-row style="margin: 15px; overflow: auto; height: 50%">
          {{ openedFile?.rawText }}
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="openFile = false"> Cancel </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      :value="openJsonEditModal"
      persistent
      @click:outside="openJsonEditModal = false"
    >
      <v-card style="display: flex; flex-direction: column; padding: 25px">
        <v-card-title class="text-h5"> JSON Knowledge </v-card-title>
        <div class="d-flex">
          <JsonEditorVue
            style="width: 100%; height: 100px; margin-bottom: 50px"
            :mode="'text'"
            v-model="jsonKnowledge"
          />
        </div>
        <v-checkbox
          v-model="isNowSet"
          label="Include current date and time"
          @change="includeNow"
        ></v-checkbox>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="openJsonEditModal = false"> Cancel </v-btn>
          <v-btn text @click="updateMemory"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <attach-from-google-drive
      :dialog="attachGoogleDriveOpen"
      @close="attachGoogleDriveOpen = false"
    />
    <attach-from-one-drive
      :dialog="attachOneDriveOpen"
      @close="attachOneDriveOpen = false"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import JsonEditorVue from 'json-editor-vue';
import cloneDeep from 'lodash/cloneDeep';
import constants from '@/util/constants';
import OneDriveIcon from '@/views/ai-workspaces/workspace/knowledge/icons/onedrive.vue';
import GoogleDriveIcon from '@/views/ai-workspaces/workspace/knowledge/icons/googledrive.vue';
import AttachFromGoogleDrive from '@/views/ai-workspaces/workspace/knowledge/attach/googledrive.vue';
import AttachFromOneDrive from '@/views/ai-workspaces/workspace/knowledge/attach/onedrive.vue';

const {
  mapGetters: workspacesGetters,
  mapActions: workspaceActions,
  mapMutations: workspacesMutations,
} = createNamespacedHelpers('aiWorkspace');

export default {
  name: 'AgentKnowledge',
  components: {
    AttachFromOneDrive,
    AttachFromGoogleDrive,
    JsonEditorVue,
    OneDriveIcon,
    GoogleDriveIcon,
  },
  props: {
    jsonKnowledge: {
      type: Object,
    },
  },
  data() {
    return {
      openFile: false,
      isNowSet: true,
      publicPath: constants.isDevelopment ? '' : '',
      filesSize: 0,
      openedFile: null,
      attachGoogleDriveOpen: false,
      attachOneDriveOpen: false,
      openJsonEditModal: false,
    };
  },
  watch: {
    workspace() {
      if (!this.jsonKnowledge) {
        this.setWorkspaceJsonKnowledge({
          now: true,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        });
      }
      if (!this.jsonKnowledge?.now) {
        this.isNowSet = false;
      } else {
        this.isNowSet = true;
      }

      if (this?.workspace?.id) {
        this.getWorkspaceKnowledge({ workspaceId: this.workspace.id });
      }
    },
  },
  computed: {
    ...workspacesGetters({
      files: 'WORKSPACE_KNOWLEDGE_FILES',
      workspace: 'WORKSPACE',
      isFilesLoading: 'WORKSPACE_KNOWLEDGE_FILES_LOADING',
    }),
  },
  methods: {
    ...workspaceActions([
      'getWorkspaceKnowledge',
      'addWorkspaceKnowledge',
      'deleteWorkspaceKnowledge',
      'getKnowledgeRawText',
    ]),
    ...workspacesMutations({
      setWorkspaceJsonKnowledge: 'SET_WORKSPACE_JSON_KNOWLEDGE',
    }),
    getFilesSize() {
      let size = 0;
      this.files.map((file) => {
        size += Number(file.size);
      });
      this.filesSize = size / 1024 / 1024;
      return size / 1024 / 10.24 / 2;
    },
    validateSize(input) {
      return this.filesSize + input.size / 1024 / 1024 > 2;
    },
    async openFileModal(file) {
      if (file.type.includes('google') && file.type.includes('document')) {
        window.open(
          `https://docs.google.com/document/d/${file.externalLocation}/edit`,
          '_blank'
        );
        return;
      }
      if (file.type.includes('google') && file.type.includes('spreadsheet')) {
        window.open(
          `https://docs.google.com/spreadsheets/d/${file.externalLocation}/edit`,
          '_blank'
        );
        return;
      }
      if (file.type.includes('google')) {
        window.open(
            `https://drive.google.com/file/d/${file.externalLocation}/view`,
            '_blank'
        );
        return;
      }
      if (file.type.includes('onedrive')) {
        window.open(file.externalLink);
        return;
      }
      const data = await this.getKnowledgeRawText({
        workspaceId: this.workspace.id,
        knowledgeId: file.id,
      });
      this.openedFile = data;
      this.openFile = true;
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
      });
    },
    async onFileDelete(id) {
      await this.deleteWorkspaceKnowledge({
        workspaceId: this.workspace.id,
        knowledgeId: id,
      });
    },
    async onFileChange(events) {
      for (let thisFile of events) {
        if (this.validateSize(thisFile)) {
          this.$store.dispatch(
            'notifications/setError',
            `Knowledge size limit exceeded`
          );
          return;
        }
        const base64 = await this.toBase64(thisFile);
        await this.addWorkspaceKnowledge({
          files: [
            {
              workspaceId: this.workspace.id,
              base64: base64,
              type: thisFile.type,
              name: thisFile.name,
              size: thisFile.size,
            },
          ],
          workspaceId: this.workspace.id,
        });
      }
    },
    includeNow(value) {
      let jsonKnowledgeData = cloneDeep(this.jsonKnowledge);
      jsonKnowledgeData ??= {};
      if (typeof jsonKnowledgeData === 'string') {
        jsonKnowledgeData = JSON.parse(jsonKnowledgeData);
      }
      jsonKnowledgeData['now'] = value;
      if (value) {
        jsonKnowledgeData['timezone'] =
          Intl.DateTimeFormat().resolvedOptions().timeZone;
      } else {
        delete jsonKnowledgeData['timezone'];
      }
      this.setWorkspaceJsonKnowledge(jsonKnowledgeData);
    },
    async updateMemory() {
      this.$emit('jsonKnowledgeChanged', this.jsonKnowledge);
      this.openJsonEditModal = false;
      this.$emit('close');
    },
    setDefaultJsonKnowledge() {
      if (!this.jsonKnowledge) {
        this.setWorkspaceJsonKnowledge({
          now: true,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        });
      }
      if (!this.jsonKnowledge?.now) {
        this.isNowSet = false;
      }
    },
  },
  mounted() {
    this.setDefaultJsonKnowledge();
  },
  created() {
    if (this?.workspace?.id) {
      this.getWorkspaceKnowledge({ workspaceId: this.workspace.id });
    }
    this.setDefaultJsonKnowledge();
  },
};
</script>

<style lang="scss" scoped>
@import 'workspace-knowledge';
</style>
